import React from 'react'

import { RadioButton } from '../baseInputs'

type Props = {
  inputLabel?: string
}

const CommunicationsPreferences = ({ inputLabel, ...rest }: Props) => {
  const label = inputLabel || `Communications Preferences`

  return (
    <div className="mb-4 md:mb-2" data-gt-name="componentevent">
      <div>
        <h3 className={`text-l md:text-xl lg:text-2xl mb-3 !leading-snug`}>
          {label}
        </h3>
        <p className="text-tiny mb-4">
          Please select your communications options:
        </p>

        <div>
          <div className="mb-4">
            <p className=""> Relevant Offers</p>
            <p className="text-tiny leading-snug">
              By selecting &quot;Yes&quot; we will send you communications and
              offers directly or through our dealerships about our and our
              partners&apos; products and services that are relevant or may be
              of interest to you such as communications about upgrades to your
              vehicle, finance arrangements and finance renewal, insurance and
              other products and services. This way you will never miss out.
            </p>
          </div>

          <div className="radio-btn-container flex">
            <RadioButton
              errorDisabled
              name="communication_relevantoffers"
              label="Yes"
              value={true}
              {...rest}
            />
            <RadioButton
              errorDisabled
              name="communication_relevantoffers"
              label="No"
              value={false}
              {...rest}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommunicationsPreferences
